import { createStyles } from "@mantine/core";

export const useStyles = createStyles((theme) => ({
  modalBody: {
    backgroundColor: "#d3e1e2",
  },
}));